import { apiClient } from "@/services/HttpService";

export function listPartners(params) {
  return apiClient.post("/partner/search", params);
}

export function savePartner(params) {
  return apiClient.post("/partner", params);
}

export function delPartner(partnerId) {
  return apiClient.delete(`/partner/${partnerId}`);
}

export function listOptions(){
  return apiClient.get("/partner/options");
}